import { useState, useEffect, forwardRef } from "react";
import ReactSelect from 'react-select';
import Fetch from '../../../../../util/core/Fetch';
import sleep from 'sleep-promise';

const Select = forwardRef((props, ref) => {

  let [value, updateValue] = useState(props.value);
  let [options, updateOptions] = useState(props.options);
  let [error, updateError] = useState(props.error);
  let [readOnly, setReadOnly] = useState(false);
  let [sort, setSort] = useState((typeof props.sort === "undefined")?'ASC':props.sort); 
  let className = '';
  let customStyle = {};

  useEffect(() => {
    const loadOptions = async () => {
      let option = {}

      if(value && typeof value === 'object' && value[0]){
        value = value[0];
      }

      const rawValue = value && typeof value === 'object' ? value.value : value;

      option = options.filter(selected => selected.value == rawValue);
      updateValue(option);

      if (props.optionsEndpoint && props.optionsEndpoint.endpoint) {
        let url = props.optionsEndpoint.endpoint;
        let keyLabel = props.optionsEndpoint.label;
        let keyValue = props.optionsEndpoint.value;
        const params = props.optionsEndpoint.params ? props.optionsEndpoint.params : {};
        let rows = await Fetch.post(url, params);

        let tempOptions = rows.map(item => (
          {
            value: item[keyValue],
            label: item[keyLabel]
          }
        ));
        option = tempOptions.filter(selected => selected.value == rawValue);
        

        if(sort){
          tempOptions.sort((a, b) => {
            const labelA = a.label?a.label:'';
            const labelB = b.label?b.label:'';
            let fa = labelA.toLowerCase(),
            fb = labelB.toLowerCase();
            if (fa < fb) {
                return -1;
            }
            if (fa > fb) {
                return 1;
            }
            return 0;
          });

          if(sort == 'DESC'){
            tempOptions = tempOptions.reverse()
          }
        }

        updateOptions(tempOptions);
        updateValue(option);

        if (tempOptions.length === 1 && props.canAutoFill && props.required) {
          updateValue(tempOptions[0]);
          handleChange(tempOptions[0]);
          setReadOnly(true);
        }
      }
    }
    loadOptions();

  }, [props.value, props.optionsEndpoint?.updateOptions]);

  const handleChange = element => {
    const target = {
      name: props.name,
      type: 'select',
      ...element
    }
    updateValue(element);
    props.onChange({ target: target });
  };

  if (props.error) {
    className = "is-invalid";
    customStyle = { border: '1px solid #dc3545' };
  }

  return (
    <div ref={ref}>
      <div style={customStyle}>
        <ReactSelect
          styles={{
            menu: (baseStyles, state) => ({
              ...baseStyles,
              zIndex: 100
            }),
            ...props.styles,
          }}
          autoFocus={props.autoFocus ? true : false}
          isClearable={props.isClearable === false ? false : readOnly
            ? false
            : props.value !== null
          }
          name={props.name}
          placeholder={props.placeholder ? props.placeholder : 'Selecione'}
          options={options}
          onChange={handleChange}
          value={value}
          isDisabled={props.disabled}
          isSearchable={!readOnly}
          menuIsOpen={readOnly ? false : undefined}
        />
      </div>
      {props.error && (
        <span
          className="error invalid-feedback"
          style={{ display: 'inline' }}>
          {props.error}
        </span>
      )}


    </div>
  );
})
export default Select;

